import { createBrowserHistory } from 'history'
import { configureStore as configureReduxStore } from '@reduxjs/toolkit'

import { rootApi } from 'root-api'

export const createStore = (reducer, preloadedState = {}, history = createBrowserHistory()) => (
  configureReduxStore({
    reducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      thunk: {
        extraArgument: { history }
      },
      serializableCheck: false,
      immutableCheck: {
        warnAfter: 1000
      }
    }).concat(rootApi.middleware)
  })
)
